module.exports = __webpack_public_path__ + "img/header-ebook.ebad5772.png";